import { useDebouncedValue } from "@mantine/hooks";
import { useEffect } from "react";

import { useServiceClient } from "@megaron/react-clients";

import {
  resolveInvoiceNumberForOrder,
  resolveOrderNumberForInvoice,
} from "./supportTicketInvoiceOrderDocSearch";

type Params = {
  invoiceNumber: string;
  orderNumber: string;
  setInvoiceNumber: (value: string) => void;
  setOrderNumber: (value: string) => void;
};

export const useSupportTicketInvoiceOrderSync = ({
  invoiceNumber,
  orderNumber,
  setInvoiceNumber,
  setOrderNumber,
}: Params) => {
  const docs = useServiceClient("docs");
  const [debouncedInvoiceNumber] = useDebouncedValue(invoiceNumber.trim(), 400);
  const [debouncedOrderNumber] = useDebouncedValue(orderNumber.trim(), 400);

  useEffect(() => {
    if (!debouncedInvoiceNumber || orderNumber.trim()) return;

    let isCancelled = false;

    const sync = async () => {
      const resolvedOrderNumber = await resolveOrderNumberForInvoice(docs, debouncedInvoiceNumber);
      if (!isCancelled && resolvedOrderNumber) {
        setOrderNumber(resolvedOrderNumber);
      }
    };

    void sync();

    return () => {
      isCancelled = true;
    };
  }, [debouncedInvoiceNumber, docs, orderNumber, setOrderNumber]);

  useEffect(() => {
    if (!debouncedOrderNumber || invoiceNumber.trim()) return;

    let isCancelled = false;

    const sync = async () => {
      const resolvedInvoiceNumber = await resolveInvoiceNumberForOrder(docs, debouncedOrderNumber);
      if (!isCancelled && resolvedInvoiceNumber) {
        setInvoiceNumber(resolvedInvoiceNumber);
      }
    };

    void sync();

    return () => {
      isCancelled = true;
    };
  }, [debouncedOrderNumber, docs, invoiceNumber, setInvoiceNumber]);
};
